/* eslint-disable */ import { memoEval, sceneEntityPropertiesComponent, sceneEntityRemoteMaterialOverrideComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const cabinetComponents = [
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('Cabinet').attach(memoEval((self)=>[
            self.offsetX
        ], (offsetX)=>({
            offsetX: offsetX
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'body', true).withAlias('Cabinet').attach(memoEval((self)=>[
            self.$material,
            self.$color
        ], ($material, $color)=>({
            fileUrl: '/models/higgins.glb',
            materialName: $material,
            materialsToOverride: [
                'cabinetBodyMaterial'
            ],
            color: $color
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'hardware', true).withAlias('Cabinet').attach(memoEval((self)=>[
            self.$hardwareMaterialColor
        ], ($hardwareMaterialColor)=>({
            fileUrl: '/models/higgins.glb',
            materialName: 'hardwareMaterial',
            materialsToOverride: [
                'hardwareMaterial'
            ],
            color: $hardwareMaterialColor
        })))
];

//# sourceMappingURL=cabinet.js.map